import { SxProps, Theme } from '@mui/material';

export const titleSX: SxProps<Theme> = {
	color: 'text.primary',
	fontSize: 'var(--font-size-lg)',
	fontWeight: '800',
	textAlign: 'center',
	p: { xs: '17px 0', sm: '0px' },
};

export const subtitleSX: SxProps<Theme> = {
	mt: '9px',
	fontSize: 'var(--font-size-body)',
	fontWeight: 'normal',
	color: '#2C2C2C',
	letterSpacing: '0px',
};

export const buttonSX: SxProps<Theme> = {
	width: '100%',
	minHeight: '55px',
	borderRadius: '28px',
	paddingTop: '9px',
	paddingBottom: '9px',
	backgroundColor: '#774A91',
};

export const gridItemSX: SxProps<Theme> = {
	backgroundColor: 'transparent',
};
